import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import pipe from 'ramda/src/pipe';
import NewSubscriptionPlan from '../components/NewSubscriptionPlan';
import { trimData } from '../../../common/trimData';
import { createSubscriptionPlan } from '../actions';

const NewSubscriptionPlanContainer = compose(
  connect(null, { createSubscriptionPlan }),
  withHandlers({
    onSubmit: props => pipe(trimData, props.createSubscriptionPlan),
  })
)(NewSubscriptionPlan);

export default NewSubscriptionPlanContainer;
